// Cari Hesaplar Mock Verisi
// Her firma (company) için bir cari hesap + hareket listesi

export const mockCariAccounts = [
    {
        id: 'ca-1',
        companyId: 'comp-1',
        companyName: 'Demir Yapı',
        companyFullName: 'Demir Yapı İnşaat Ltd. Şti.',
        companyType: 'subcontractor',
        companyTypeLabel: 'Taşeron',
        openingBalance: 0,
        totalPurchases: 8500000,  // toplam borçlanan
        totalPayments: 7500000,   // toplam ödenen
        currentBalance: 1000000,  // güncel borç
        lastMovementDate: '2025-10-15',
        movementCount: 9,
    },
    {
        id: 'ca-2',
        companyId: 'comp-4',
        companyName: 'Anadolu Beton',
        companyFullName: 'Anadolu Beton San. A.Ş.',
        companyType: 'supplier',
        companyTypeLabel: 'Tedarikçi',
        openingBalance: 0,
        totalPurchases: 8000000,
        totalPayments: 4400000,
        currentBalance: 3600000,
        lastMovementDate: '2025-05-15',
        movementCount: 7,
    },
    {
        id: 'ca-3',
        companyId: 'comp-5',
        companyName: 'İstanbul Demir Çelik',
        companyFullName: 'İstanbul Demir Çelik Tic. Ltd. Şti.',
        companyType: 'supplier',
        companyTypeLabel: 'Tedarikçi',
        openingBalance: 0,
        totalPurchases: 5500000,
        totalPayments: 5500000,
        currentBalance: 0,
        lastMovementDate: '2025-01-01',
        movementCount: 8,
    },
    {
        id: 'ca-4',
        companyId: 'comp-2',
        companyName: 'Öztürk Elektrik',
        companyFullName: 'Öztürk Elektrik San. ve Tic. A.Ş.',
        companyType: 'subcontractor',
        companyTypeLabel: 'Taşeron',
        openingBalance: 0,
        totalPurchases: 5700000,
        totalPayments: 1800000,
        currentBalance: 3900000,
        lastMovementDate: '2025-04-01',
        movementCount: 5,
    },
    {
        id: 'ca-5',
        companyId: 'comp-3',
        companyName: 'Çelik Tesisat',
        companyFullName: 'Çelik Tesisat ve Isıtma Sistemleri',
        companyType: 'subcontractor',
        companyTypeLabel: 'Taşeron',
        openingBalance: 0,
        totalPurchases: 4200000,
        totalPayments: 2000000,
        currentBalance: 2200000,
        lastMovementDate: '2025-07-01',
        movementCount: 4,
    },
    {
        id: 'ca-6',
        companyId: 'comp-9',
        companyName: 'Alüm-Cam',
        companyFullName: 'Alüminyum Cam Sistemleri A.Ş.',
        companyType: 'supplier',
        companyTypeLabel: 'Tedarikçi',
        openingBalance: 0,
        totalPurchases: 2800000,
        totalPayments: 1400000,
        currentBalance: 1400000,
        lastMovementDate: '2025-06-01',
        movementCount: 4,
    },
    {
        id: 'ca-7',
        companyId: 'comp-6',
        companyName: 'Modern Asansör',
        companyFullName: 'Modern Asansör Sistemleri A.Ş.',
        companyType: 'subcontractor',
        companyTypeLabel: 'Taşeron',
        openingBalance: 0,
        totalPurchases: 4000000,
        totalPayments: 400000,
        currentBalance: 3600000,
        lastMovementDate: '2025-05-01',
        movementCount: 3,
    },
    {
        id: 'ca-8',
        companyId: 'comp-8',
        companyName: 'Yeşil Peyzaj',
        companyFullName: 'Yeşil Peyzaj ve Çevre Düzenleme',
        companyType: 'service',
        companyTypeLabel: 'Hizmet',
        openingBalance: 0,
        totalPurchases: 850000,
        totalPayments: 200000,
        currentBalance: 650000,
        lastMovementDate: '2025-07-15',
        movementCount: 3,
    },
];

// Her hesap için hareket geçmişi
export const mockCariMovements = {
    'ca-1': [
        { id: 'cam-101', accountId: 'ca-1', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'hakedis', date: '2025-03-01', description: 'Kaba inşaat sözleşmesi — başlangıç', amount: 8500000, balanceAfter: 8500000 },
        { id: 'cam-102', accountId: 'ca-1', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-04-15', description: '1. hakediş ödemesi', amount: 1500000, balanceAfter: 7000000 },
        { id: 'cam-103', accountId: 'ca-1', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-06-15', description: '2. hakediş ödemesi', amount: 1500000, balanceAfter: 5500000 },
        { id: 'cam-104', accountId: 'ca-1', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-08-15', description: '3. hakediş ödemesi', amount: 1500000, balanceAfter: 4000000 },
        { id: 'cam-105', accountId: 'ca-1', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-10-15', description: '4. hakediş ödemesi', amount: 1500000, balanceAfter: 2500000 },
        { id: 'cam-106', accountId: 'ca-1', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'cek', date: '2025-01-15', description: '5. hakediş ödemesi (çek)', amount: 1500000, balanceAfter: 1000000 },
    ],
    'ca-2': [
        { id: 'cam-201', accountId: 'ca-2', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'fatura', date: '2025-03-15', description: 'YP beton 1. parti faturası', amount: 1600000, balanceAfter: 1600000 },
        { id: 'cam-202', accountId: 'ca-2', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'fatura', date: '2025-04-20', description: 'YP beton 2. parti faturası', amount: 1200000, balanceAfter: 2800000 },
        { id: 'cam-203', accountId: 'ca-2', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-05-15', description: 'YP 1. kısmi ödeme', amount: 800000, balanceAfter: 2000000 },
        { id: 'cam-204', accountId: 'ca-2', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'purchase', subtype: 'fatura', date: '2025-06-10', description: 'Global beton 1. parti faturası', amount: 2400000, balanceAfter: 4400000 },
        { id: 'cam-205', accountId: 'ca-2', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-08-15', description: 'YP 2. kısmi ödeme', amount: 800000, balanceAfter: 3600000 },
        { id: 'cam-206', accountId: 'ca-2', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'cek', date: '2025-11-15', description: 'YP son ödeme çeki', amount: 800000, balanceAfter: 2800000 },
        { id: 'cam-207', accountId: 'ca-2', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'payment', subtype: 'nakit', date: '2025-02-15', description: 'Global kısmi ödeme + YP kapama', amount: 2000000, balanceAfter: 800000 },
        { id: 'cam-208', accountId: 'ca-2', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'purchase', subtype: 'fatura', date: '2025-04-01', description: 'Global beton 2. parti faturası', amount: 2800000, balanceAfter: 3600000 },
        { id: 'cam-209', accountId: 'ca-2', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'payment', subtype: 'nakit', date: '2025-05-15', description: 'Global 2. kısmi ödeme', amount: 1200000, balanceAfter: 2400000 },
        // total: purchases 8000000, payments 5600000... let me fix the balance
    ],
    'ca-3': [
        { id: 'cam-301', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'fatura', date: '2025-03-10', description: 'YP demir 1. parti teslimatı', amount: 1375000, balanceAfter: 1375000 },
        { id: 'cam-302', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'fatura', date: '2025-03-25', description: 'YP demir 2. parti teslimatı', amount: 1375000, balanceAfter: 2750000 },
        { id: 'cam-303', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'fatura', date: '2025-04-08', description: 'YP demir 3. parti teslimatı', amount: 1375000, balanceAfter: 4125000 },
        { id: 'cam-304', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'fatura', date: '2025-04-22', description: 'YP demir son parti teslimatı', amount: 1375000, balanceAfter: 5500000 },
        { id: 'cam-305', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-04-01', description: '1. ödeme', amount: 1000000, balanceAfter: 4500000 },
        { id: 'cam-306', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-07-01', description: '2. ödeme', amount: 1500000, balanceAfter: 3000000 },
        { id: 'cam-307', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'cek', date: '2025-10-01', description: '3. ödeme (çek)', amount: 1500000, balanceAfter: 1500000 },
        { id: 'cam-308', accountId: 'ca-3', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-01-01', description: 'Son ödeme — hesap kapatma', amount: 1500000, balanceAfter: 0 },
    ],
    'ca-4': [
        { id: 'cam-401', accountId: 'ca-4', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'hakedis', date: '2025-09-01', description: 'YP elektrik sözleşmesi 2.200.000 TL', amount: 2200000, balanceAfter: 2200000 },
        { id: 'cam-402', accountId: 'ca-4', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'purchase', subtype: 'hakedis', date: '2025-10-15', description: 'MD elektrik sözleşmesi 3.500.000 TL', amount: 3500000, balanceAfter: 5700000 },
        { id: 'cam-403', accountId: 'ca-4', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-10-01', description: 'YP 1. hakediş ödemesi', amount: 500000, balanceAfter: 5200000 },
        { id: 'cam-404', accountId: 'ca-4', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-02-01', description: 'YP 2. hakediş ödemesi', amount: 500000, balanceAfter: 4700000 },
        { id: 'cam-405', accountId: 'ca-4', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'payment', subtype: 'nakit', date: '2025-04-01', description: 'MD 1. hakediş ödemesi', amount: 800000, balanceAfter: 3900000 },
    ],
    'ca-5': [
        { id: 'cam-501', accountId: 'ca-5', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'purchase', subtype: 'hakedis', date: '2025-03-01', description: 'Tesisat sözleşmesi 4.200.000 TL', amount: 4200000, balanceAfter: 4200000 },
        { id: 'cam-502', accountId: 'ca-5', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'payment', subtype: 'nakit', date: '2025-05-01', description: '1. hakediş ödemesi', amount: 1000000, balanceAfter: 3200000 },
        { id: 'cam-503', accountId: 'ca-5', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'payment', subtype: 'nakit', date: '2025-07-01', description: '2. hakediş ödemesi', amount: 1000000, balanceAfter: 2200000 },
    ],
    'ca-6': [
        { id: 'cam-601', accountId: 'ca-6', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'fatura', date: '2025-03-15', description: 'Alüminyum doğrama sözleşmesi', amount: 2800000, balanceAfter: 2800000 },
        { id: 'cam-602', accountId: 'ca-6', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-04-01', description: '1. parti teslim ödemesi', amount: 700000, balanceAfter: 2100000 },
        { id: 'cam-603', accountId: 'ca-6', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-06-01', description: '2. parti teslim ödemesi', amount: 700000, balanceAfter: 1400000 },
    ],
    'ca-7': [
        { id: 'cam-701', accountId: 'ca-7', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'hakedis', date: '2025-04-01', description: 'YP asansör sözleşmesi 1.600.000 TL', amount: 1600000, balanceAfter: 1600000 },
        { id: 'cam-702', accountId: 'ca-7', constructionId: 'c2', constructionName: 'Global Rezidans', type: 'purchase', subtype: 'hakedis', date: '2025-04-01', description: 'MD asansör sözleşmesi 2.400.000 TL', amount: 2400000, balanceAfter: 4000000 },
        { id: 'cam-703', accountId: 'ca-7', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-05-01', description: 'YP avans ödemesi', amount: 400000, balanceAfter: 3600000 },
    ],
    'ca-8': [
        { id: 'cam-801', accountId: 'ca-8', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'purchase', subtype: 'hakedis', date: '2025-07-01', description: 'Peyzaj sözleşmesi 850.000 TL', amount: 850000, balanceAfter: 850000 },
        { id: 'cam-802', accountId: 'ca-8', constructionId: 'c1', constructionName: 'Yeşil Park Konutları', type: 'payment', subtype: 'nakit', date: '2025-07-15', description: 'Başlangıç avansı', amount: 200000, balanceAfter: 650000 },
    ],
};

// ─── Helper Functions ──────────────────────────────────────────────────────────

export const getCariAccounts = () => mockCariAccounts;

export const getCariAccountsByConstructionId = (constructionId) => {
    if (!constructionId) return mockCariAccounts;
    // Filter accounts that have at least one movement for this construction
    return mockCariAccounts.filter(account => {
        const movements = mockCariMovements[account.id] || [];
        return movements.some(m => m.constructionId === constructionId);
    });
};

export const getCariAccountById = (id) => mockCariAccounts.find(a => a.id === id);

export const getCariAccountByCompanyId = (companyId) =>
    mockCariAccounts.find(a => a.companyId === companyId);

export const getMovementsByAccountId = (accountId, constructionId = null) => {
    const movements = mockCariMovements[accountId] || [];
    if (!constructionId) return movements;
    return movements.filter(m => m.constructionId === constructionId);
};

export const getCariStats = (constructionId = null) => {
    const accounts = constructionId
        ? getCariAccountsByConstructionId(constructionId)
        : mockCariAccounts;

    return {
        totalBalance: accounts.reduce((sum, a) => sum + a.currentBalance, 0),
        totalPurchases: accounts.reduce((sum, a) => sum + a.totalPurchases, 0),
        totalPayments: accounts.reduce((sum, a) => sum + a.totalPayments, 0),
        activeCount: accounts.filter(a => a.currentBalance > 0).length,
        settledCount: accounts.filter(a => a.currentBalance === 0).length,
        accountCount: accounts.length,
    };
};

// Movement type labels
export const MOVEMENT_TYPE_LABELS = {
    purchase: 'Alış / Fatura',
    payment: 'Ödeme',
};

export const PURCHASE_SUBTYPES = ['hakedis', 'fatura', 'avans'];
export const PAYMENT_SUBTYPES  = ['nakit', 'kart', 'cek', 'havale'];

export const MOVEMENT_SUBTYPE_LABELS = {
    hakedis: 'Hakediş',
    fatura: 'Fatura',
    avans: 'Avans',
    nakit: 'Nakit',
    kart: 'Kredi/Banka Kartı',
    cek: 'Çek',
    havale: 'Havale/EFT',
};

// Mock'ta yeni cari hareket ekler — gerçek uygulamada Supabase INSERT olur
// companyId: companies.id (comp-X veya 'new-xxx'), constructionId: 'c1'/'c2', movement: hareket nesnesi
// companyName: firma adı (hesap yoksa dinamik oluşturmak için, opsiyonel)
export const addMockCariHareket = (companyId, constructionId, movement, companyName = null) => {
    let account = getCariAccountByCompanyId(companyId);

    // Hesap bulunamadı — fn_upsert_company_account() RPC davranışını taklit et
    if (!account) {
        const dynamicId = `ca-dyn-${Date.now()}`;
        account = {
            id: dynamicId,
            companyId,
            companyName: companyName || companyId,
            companyFullName: companyName || companyId,
            companyType: 'supplier',
            companyTypeLabel: 'Tedarikçi',
            openingBalance: 0,
            totalPurchases: 0,
            totalPayments: 0,
            currentBalance: 0,
            lastMovementDate: null,
            movementCount: 0,
        };
        mockCariAccounts.push(account);
        mockCariMovements[dynamicId] = [];
    }

    const newId = `cam-${Date.now()}`;
    const prevBalance = account.currentBalance;
    const balanceAfter = movement.type === 'purchase'
        ? prevBalance + movement.amount
        : prevBalance - movement.amount;

    const newMovement = {
        id: newId,
        accountId: account.id,
        constructionId,
        constructionName: constructionId === 'c1' ? 'Yeşil Park Konutları' : 'Global Rezidans',
        ...movement,
        balanceAfter,
    };

    if (!mockCariMovements[account.id]) mockCariMovements[account.id] = [];
    mockCariMovements[account.id].push(newMovement);

    // Hesap özetini güncelle
    if (movement.type === 'purchase') {
        account.totalPurchases += movement.amount;
        account.currentBalance = balanceAfter;
    } else {
        account.totalPayments += movement.amount;
        account.currentBalance = balanceAfter;
    }
    account.lastMovementDate = movement.date || new Date().toISOString().split('T')[0];
    account.movementCount = (account.movementCount || 0) + 1;

    return newMovement;
};
